/* tslint:disable */
/* eslint-disable */
/**
 * Credit API
 * API for banking integrations
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { AccountAccountTypeName } from './account-account-type-name';

/**
 * 
 * @export
 * @interface Account
 */
export interface Account {
    /**
     * 
     * @type {number}
     * @memberof Account
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof Account
     */
    'accessTokenId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'bankSlug'?: string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'accountNumber'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Account
     */
    'active'?: boolean | null;
    /**
     * INITIAL_INTEGRATION_NOT_STARTED: Initial integration not started, ACTIVE: Active, NO_LONGER_AVAILABLE: No longer available, token expired
     * @type {string}
     * @memberof Account
     */
    'status'?: AccountStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'branchNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'branchName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'currency'?: string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'accountCategory'?: string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'accountType'?: string | null;
    /**
     * 
     * @type {AccountAccountTypeName}
     * @memberof Account
     */
    'accountTypeName'?: AccountAccountTypeName;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'provider'?: AccountProviderEnum;
}

export const AccountStatusEnum = {
    initialIntegrationNotStarted: 'INITIAL_INTEGRATION_NOT_STARTED',
    active: 'ACTIVE',
    noLongerAvailable: 'NO_LONGER_AVAILABLE'
} as const;

export type AccountStatusEnum = typeof AccountStatusEnum[keyof typeof AccountStatusEnum];
export const AccountProviderEnum = {
    credit: 'CREDIT',
    moneytree: 'MONEYTREE'
} as const;

export type AccountProviderEnum = typeof AccountProviderEnum[keyof typeof AccountProviderEnum];


